'use client';

import Breadcrumb from './Breadcrumb';
import { RichText } from '@/components/shared/RichText';

interface PageHeroProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: { label: string; href?: string }[];
}

export function PageHero({ title, subtitle, breadcrumbs }: PageHeroProps) {
  return (
    <section className="relative bg-navy pt-[120px] md:pt-[160px] pb-10 md:pb-[72px] px-5 md:px-[40px]">
      <div className="relative max-w-[1170px] mx-auto">
        {breadcrumbs && breadcrumbs.length > 0 && <Breadcrumb items={breadcrumbs} />}
        <h1
          className={`${breadcrumbs ? 'mt-4' : ''} text-[36px] md:text-[48px] lg:text-[55px] font-bold text-white leading-tight font-heading`}
        >
          {title}
        </h1>
      </div>
    </section>
  );
}
